"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var omit_1 = __importDefault(require("lodash/omit"));
var ClassNameExtendableHoC = function (Component, defaultClassName, classMapper, blockProps) { return function (props) {
    var newProps = blockProps
        ? (0, omit_1.default)(props, blockProps)
        : props;
    return ((0, jsx_runtime_1.jsx)(Component, __assign({}, newProps, { className: (0, clsx_1.default)(defaultClassName, classMapper === null || classMapper === void 0 ? void 0 : classMapper(props), props.className) })));
}; };
exports.default = ClassNameExtendableHoC;
